import { FormattedMessage, useIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { SgwtAccountCenter } from '@sgwt/sgwt-widgets-react';
import { Image } from '../Image';

export const Header = () => {
  const toggleMobileMenu = () => {
    document.getElementsByClassName('navbar-menu-dropdown')[0].classList.toggle('show');
  };
  const intl = useIntl();

  return (
    <header role="banner" className="bg-lvl1">
      <nav className="navbar navbar-lg">
        <div className="navbar-title">
          <NavLink to={`/${intl.locale}/`} className="navbar-title-link">
            <div className="navbar-logo">
              <Image src={'socgen_logo_full.svg'} alt="SG logo"></Image>
            </div>
            <div className="navbar-title-divider"></div>
            <div className="navbar-service-name">Design</div>
          </NavLink>
          <button
            className="navbar-menu-btn btn btn-flat btn-xl btn-icon flex-center"
            type="button"
            onClick={toggleMobileMenu}
            data-bs-toggle="dropdown"
            data-bs-offset="0,4"
            aria-expanded="true"
          >
            <svg
              className="icon"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="2" y="6" width="20" height="2" fill="currentColor"></rect>
              <rect x="2" y="11" width="20" height="2" fill="currentColor"></rect>
              <rect x="2" y="16" width="20" height="2" fill="currentColor"></rect>
            </svg>
          </button>
          <ul className="navbar-menu-dropdown dropdown-menu w-100" data-bs-popper="static">
            <li className="navbar-item">
              <NavLink to={`/${intl.locale}/`} className="navbar-link" onClick={toggleMobileMenu}>
                <FormattedMessage id="header.menu.design" />
              </NavLink>
            </li>
            <li className="navbar-item">
              <NavLink to={`/${intl.locale}/approach`} className="navbar-link" onClick={toggleMobileMenu}>
                <FormattedMessage id="header.menu.approach" />
              </NavLink>
            </li>
            <li className="navbar-item">
              <NavLink to={`/${intl.locale}/works`} className="navbar-link" onClick={toggleMobileMenu}>
                <FormattedMessage id="header.menu.works" />
              </NavLink>
            </li>
            <li className="navbar-item">
              <NavLink to={`/${intl.locale}/join-us`} className="navbar-link" onClick={toggleMobileMenu}>
                <FormattedMessage id="header.menu.join-us" />
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="navbar-content navbar-content-container">
          <ul className="navbar-navigation m-0">
            <li className="navbar-item">
              <NavLink className="navbar-link" aria-current="page" to={`/${intl.locale}/`}>
                <FormattedMessage id="header.menu.design" />
              </NavLink>
            </li>
            <li className="navbar-item">
              <NavLink className="navbar-link" to={`/${intl.locale}/approach`}>
                <FormattedMessage id="header.menu.approach" />
              </NavLink>
            </li>
            <li className="navbar-item">
              <NavLink className="navbar-link" to={`/${intl.locale}/works`}>
                <FormattedMessage id="header.menu.works" />
              </NavLink>
            </li>
            <li className="navbar-item">
              <NavLink className="navbar-link" to={`/${intl.locale}/join-us`}>
                <FormattedMessage id="header.menu.join-us" />
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="navbar-toolbar">
          <SgwtAccountCenter
            availableLanguages={['en', 'fr']}
            authentication="sg-connect"
            showLanguagesSelection
            hideServicesLink
            mode="sg-markets"
          />
        </div>
      </nav>
    </header>
  );
};
